// API =>
import axios from "axios";

const backEnd = axios.create({
    baseURL: "https://wedookbrand.com/api/v1/",
    // baseURL: "http://localhost:8000/api/v1/",
    withCredentials: true,
    xsrfCookieName: "csrftoken",
    xsrfHeaderName: "X-CSRFToken",
});

export default backEnd;
